// extracted by css-extract-rspack-plugin
export default {"root":"z36Dze","link-overlay":"ssOGzg","linkOverlay":"ssOGzg"};